export interface ListingPriceProps {
  price: number;
  saleOrLease: string;
}

export const ListingPrice = (props: ListingPriceProps) => {

  return (
    <div className="listing-price">${props.price.toLocaleString()} {props.saleOrLease === 'lease' && '/ month'}</div>
  );
}
